import * as React from 'react';

import { Spacer, Typography } from '@emburse/ui-core';

import { ConfirmModal, IConfirmModalBaseProps } from '@ReactComponents/ConfirmModal';

interface ISignUpDupeModal extends IConfirmModalBaseProps {
  isLoading: boolean;
}

export function SignUpDupeModal(props: ISignUpDupeModal) {
  const { closeModal, onConfirm, isLoading } = props;

  return (
    // our modal is a reverse confirm modal so cancel and confirm are swapped
    <ConfirmModal
      headerText="Potential Duplicate Company"
      cancelText="Proceed"
      confirmText="Cancel"
      closeModal={onConfirm} // intentional swap for the button actions for css
      onConfirm={closeModal}
      isLoading={isLoading}
    >
      <Typography>
        A company with this name already exists. Creating another may cause account management issues. Are you sure you want to{' '}
        <strong>proceed</strong> with creating a duplicate or <strong>cancel</strong> and review company details?
      </Typography>
      <Spacer size={16} />
    </ConfirmModal>
  );
}
